'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

var _arrayAsObj = require('shared/utils/arrayAsObj');

var _arrayAsObj2 = _interopRequireDefault(_arrayAsObj);

var _getTitleForLevel = require('shared/utils/getTitleForLevel');

var _getTitleForLevel2 = _interopRequireDefault(_getTitleForLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import objAsArray from 'shared/utils/objAsArray';
var getSubsector = function getSubsector(route, _ref) {
  var jobs = _ref.jobs,
      subsectors = _ref.subsectors;

  var parts = route.split('/').filter(function (el) {
    return el;
  });
  if (parts[0] === 'job') {
    var job = jobs[parts[1]];
    return (0, _extends4.default)({
      job: job
    }, subsectors[job.subsectors[0]]);
  }

  var subsectorID = (0, _keys2.default)(subsectors).filter(function (id) {
    var subsector = subsectors[id];
    return subsector.slug === parts[1];
  });

  return (0, _extends4.default)({}, subsectors[subsectorID[0]]);
}; //import objAsArray from 'shared/utils/objAsArray';


var checkJobsInLevelOrder = function checkJobsInLevelOrder(jobs) {
  var last_level = void 0;

  jobs.forEach(function (job) {
    if (!last_level) {
      last_level = job.level;
    } else if (job.level < last_level) {
      throw new Error('Error in career path, jobs out of order, starting at', job.slug, jobs.map(function (j) {
        return j.slug;
      }));
    }
  });
};

var getJobsByColumn = function getJobsByColumn(career_paths, jobs) {
  var currentJob = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var subsector = arguments[3];
  var slug = currentJob.slug;


  var populatedJobs = career_paths.map(function (key) {
    if (jobs[key]) {
      return jobs[key];
    }

    console.error('In popular career path, ' + key + ' was specified but\n                  is not found in the jobs object');
    return null;
  }).filter(function (el) {
    return el;
  }).map(function (job) {
    return (0, _extends4.default)({}, job, {
      isActive: job.slug === slug,
      match: job.matches.match
    });
  });

  checkJobsInLevelOrder(populatedJobs);

  return populatedJobs.reduce(function (levelObj, _ref2) {
    var isActive = _ref2.isActive,
        title = _ref2.title,
        description = _ref2.content,
        fullSlug = _ref2.fullSlug,
        match = _ref2.match,
        level = _ref2.level,
        image = _ref2.image,
        squareImage = _ref2.squareImage;

    var columns = (levelObj[level] || {}).columns || [];

    return (0, _extends4.default)({}, levelObj, (0, _defineProperty3.default)({}, level, (0, _extends4.default)({}, (0, _getTitleForLevel2.default)(level), {
      columns: columns.concat({
        isActive: isActive,
        title: title,
        description: description,
        match: match,
        subsector: subsector,
        fullSlug: fullSlug,
        image: image,
        squareImage: squareImage
      })
    })));
  }, {});
};

var getBookend = function getBookend(jobs, sortedKeys, position) {
  if (position === 'end') {
    var level = jobs[sortedKeys[sortedKeys.length - 1]];
    return level.columns[level.columns.length - 1];
  }

  return jobs[sortedKeys[0]].columns[0];
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var data = _ref3.data,
      user = _ref3.user;
  var route = _ref4.route;

  var _getSubsector = getSubsector(route, data),
      career_paths = _getSubsector.career_paths,
      label = _getSubsector.label,
      job = _getSubsector.job;

  var jobsWithMatch = (0, _arrayAsObj2.default)((0, _getAllMatchingJobs2.default)({
    user: user,
    data: data
  }));

  var jobsByColumn = getJobsByColumn(career_paths, jobsWithMatch, job, label);

  var sortedKeys = (0, _keys2.default)(jobsByColumn).sort();

  var start = getBookend(jobsByColumn, sortedKeys, 'start');
  var end = getBookend(jobsByColumn, sortedKeys, 'end');

  return {
    levels: sortedKeys.map(function (level) {
      return jobsByColumn[level];
    }),
    start: start,
    end: end
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps() {
  return {};
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/PopularPath/selectors.js
// module id = 1255
// module chunks = 0